import {
  IEditTask,
  IFranchiseTask,
  IParamsGetTaskList,
  IPayloadDeleteTasks,
  IResponseGetJobTaskSelection,
  IResponseGetTaskBoard,
  IResponseGetTaskFiles,
  IResponseGetTaskList,
  IResponseTask,
  IResponseTaskSelectionList,
} from '~/utils/interface/task';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { appendToFormData } from '~/utils/helper';

const taskApi = {
  getSelection() {
    return axiosClient.get<IApiBaseResponse<IResponseTaskSelectionList>>(`api/admin/tasks`);
  },

  getTask(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseTask>>(`api/admin/tasks/${id}`);
  },
  getFranchiseTask(id: string) {
    return axiosClient.get<IApiBaseResponse<IFranchiseTask>>(`api/admin/tasks/${id}`);
  },
  createFranchiseTask(data: IFranchiseTask) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/tasks/franchise`, data);
  },
  getFranchiseTaskList(params: IParamsGetTaskList) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTaskList>>(`api/admin/tasks/franchise`, { params });
  },
  createTask(data: IEditTask) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/tasks`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  createTaskCustomer(data: IEditTask) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/tasks/customer`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateTask(id: string | undefined, data: IEditTask) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/tasks/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateTaskCustomer(id: string | undefined, data: IEditTask) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/tasks/${id}/customer`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateTaskFranchise(id: string | undefined, data: IFranchiseTask) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/tasks/${id}/franchise`, data);
  },

  getTaskList(jobId: string | undefined, params: IParamsGetTaskList) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTaskList>>(`api/admin/jobs/${jobId}/tasks`, { params });
  },

  getTaskBoard(jobId: string | undefined, params: IParamsGetTaskList) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTaskBoard>>(`api/admin/jobs/${jobId}/tasks/board`, { params });
  },

  getTaskOfCustomerList(customerId: string | undefined, params: IParamsGetTaskList) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTaskList>>(`api/admin/customers/${customerId}/tasks`, {
      params,
    });
  },

  deleteTasks(data: IPayloadDeleteTasks) {
    const url = `api/admin/tasks`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },

  getFiles(jobId: string | undefined) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTaskFiles>>(`api/admin/jobs/${jobId}/files/selection`);
  },

  getJobTaskSelection(jobId: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobTaskSelection>>(`api/admin/jobs/${jobId}/tasks/selection`);
  },
};

export default taskApi;
